import { mdiAccountSupervisor } from '@mdi/js'
import Icon from '@mdi/react'
import { useTranslation } from 'react-i18next'

import { AccordionItem, AccordionItemContent, AccordionItemTrigger, AccordionRoot } from '@/components/ui/accordion'
import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'
import { IApprovalDetail, ITaskDetail } from '@/types/tasksApprovals'

import Comms from '../fields/type/user/comms'

const Assignee = ({ details }: { details: ITaskDetail | IApprovalDetail | null }) => {
    const { t } = useTranslation()

    if (!details || !('directReport' in details) || !details.directReport) {
        return null
    }

    return (
        <AccordionRoot multiple variant="gigiOutline" pb="16px">
            <AccordionItem value={t('tasksApprovals.drawer.assignee')}>
                <AccordionItemTrigger py="0" px="24px">
                    <Box as="span" flex="1" textAlign="left">
                        <Text fontSize="12px" pb="4px">
                            {t('tasksApprovals.drawer.assignee')}
                        </Text>
                        <Flex>
                            <Icon path={mdiAccountSupervisor} size="20px" />
                            <Text fontSize="14px" fontWeight="bold" pl="6px">
                                {details.directReport.name}
                            </Text>
                        </Flex>
                    </Box>
                </AccordionItemTrigger>

                <AccordionItemContent mt="16px" p="16px 24px 8px 24px">
                    <Comms email={details.directReport.email} />
                    <br />
                    <Comms link={`https://teams.microsoft.com/l/chat/0/0?users=${details.directReport.email}`} />
                </AccordionItemContent>
            </AccordionItem>
        </AccordionRoot>
    )
}
export default Assignee
